module.exports = __webpack_public_path__ + "static/img/qcx-a1.a7729f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qcx-a1.png
// module id = wuEY
// module chunks = 1